<template>
	<section>
		<!-- Componentes externos -->
    <crear-actualizar-experiencia-trabajo />
    <VerDocumento />
    <h3 class="primary--text"><v-icon color="primary">work</v-icon> Experiencia de trabajo</h3>
		<v-card>
			<v-card-text>
				<crud-table
					:headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
					:graphql="graphql"
          :initData="initData"
				>
					<!-- Template injectable de la cabecera de la tabla -->
					<template slot="buttons">
            <v-tooltip bottom>
             <v-btn color="primary" dark
               @click.native.stop="crearActualizarExperienciaTrabajo({})"
               slot="activator"
             ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
             <span>Agregar Experiencia</span>
           </v-tooltip>
          </template>
					<!-- Template de filas y columnas -->
					<template v-slot:items="items">  
						<!-- Agregar las columnas que consideré necesarias -->
            <td class="text-md-center">{{ items.item.institucion }}</td>
            <td class="text-md-center">{{ items.item.pais?items.item.pais.pais:"" }}</td>
            <td class="text-md-center">{{ items.item.puesto }}</td>
            <td class="text-md-center">{{ $moment(items.item.fecha_inicio).format("DD/MM/YYYY")  }}</td>
            <td class="text-md-center">{{ items.item.fecha_conclusion?$moment(items.item.fecha_conclusion).format("DD/MM/YYYY"):''  }}</td>
            <td class="text-md-center">{{ items.item.id_parametro_tipo_empresa==1 ? 'Publica' : 'Privada' }}</td>
            <td class="text-xs-center">{{ items.item.personal_dependiente == true ? 'Si' : 'No' }}</td>
            <td class="text-md-center">{{ items.item.nro_personas_dependientes }}</td>
            <td class="nowrap text-xs-center">
                <v-btn
                  v-if="estado==1"  
                  color="primary"
                  icon
                  @click.native="crearActualizarExperienciaTrabajo(items.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  v-if="estado==1" 
                  color="error"
                  icon
                  @click.native="deleteItem(items.item.id, 'experienciaTrabajo')">
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn
                icon
                color="info"
                @click.native="verDocumento(items.item)"
              >
                <v-icon>visibility</v-icon>
              </v-btn>
                <!-- <v-btn
                icon
                color="info"
                v-if="props.item.doc_requisitos.length > 0"
                @click.native="verDocumento(props.item.doc_requisitos[0])"
              >
                <v-icon>visibility</v-icon>
              </v-btn> -->
            </td>
          </template>
				</crud-table>
			</v-card-text>
		</v-card>
	</section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos
import CrearActualizarExperienciaTrabajo from '../dialogs/CrearActualizarExperienciaTrabajo' // Componente de creación y actualización
import VerDocumento from "../dialogs/VerDocumento.vue"

export default {
  props: ['persona'],
	// Importación de métodos y funciones de un archivo mixin 
	mixins: [crud],
	// Variables iniciales del componente
	data () {
		return {
			url: 'experienciaTrabajos',
			graphql: true,
			// Cabecera de la tabla
			headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
				{ text: 'Institución', value: 'institucion', align: 'center' },
        { text: 'País', value: 'pais', align: 'center' },
        { text: 'Puesto', value: 'puesto', align: 'center' },
        { text: 'Fecha Inicio', value: 'fecha_inicio', align: 'center' },
        { text: 'Fecha Conclusión', value: 'fecha_conclusion', align: 'center' },
        { text: 'Tipo Empresa', value: 'id_tipo_empresa', align: 'center' },
        { text: 'Personal Dependiente', value: 'personal_dependiente', align: 'center' },
        { text: 'Nro de Personas Dependientes', value: 'nro_personas_dependientes', align: 'center' },
        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
			// Campos solicitados de Graphql(Agregar los que necesite)
			dataGraphql: `
        id
        institucion
        puesto
        fecha_inicio
        fecha_conclusion
        id_parametro_tipo_empresa
        id_pais
        personal_dependiente
        nro_personas_dependientes
        nombre_jefe
        puesto_jefe
        funciones_principales
        id_parametro_motivo_finalizacion
        parametro_motivo_finalizacion{
          id
          valor
        }
        resumen_motivo
        pais{
          id
          pais
        }
        id_parametro_tipo_empresa
        id_estado
        id_persona
        _user_created
        _user_updated
        _created_at
        _updated_at
        url_documento
      `,
			// Filtros del componente CrudTable ejemplo:
			// {
			// 	field: 'Campo definido en Graphql',
			// 	label: 'Etiqueta del input generado',
			// 	type: 'text', // Tipo de input en el filtro
			// 	typeG: 'String' // Tipo definido en Graphql
			// }
			filters: [],
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.persona.id,
        },
      ],
      estado:[],
      rol:[]
		}
	},
	// Funcionalidades que se ejecutan al montar el componente
  mounted () {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0] // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }

    this.$bus.$on("verDocumento", (item) => {
      this.url = item;
      this.dialog = true;
    });

    this.obtenerEstadoFicha();
    
    this.$bus.$on('closeDialog', () => {
      this.updateList()
    })
  },
	// Métodos y funciones del componente
	methods: {
		crearActualizarExperienciaTrabajo (item) {
			this.$bus.$emit('openDialogCrearActualizarExperienciaTrabajo', item)
      
		},
    async verDocumento(item) {
    
      this.$bus.$emit("openDialogVerDocumento", item);
    },
  async recargarExperienciaTrabajo () {
      try {
        this.loading = true
        let res = await this.$service.graphql({
          query: `
            query{
              experienciaTrabajo(id: ${this.id}){
                rows{
                  id
                  institucion
                  puesto
                  fecha_inicio
                  fecha_conclusion
                  id_parametro_tipo_empresa
                  personal_dependiente
                  nro_personas_dependientes
                  nombre_jefe
                  puesto_jefe
                  funciones_principales
                  motivo_finalizacion
                  resumen_motivo
                  id_pais
                  pais{
                        id
                        pais
                      }
                  id_parametro_tipo_empresa
                  id_estado
                  id_persona
                  _user_created
                  _user_updated
                  _created_at
                  _updated_at
                }
              }
            }
          `
        })
        this.formacion_academicas = res.formacionAcademicas.rows
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
       this.rol=user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
  // deleteItem (id, url = '', idList = 'btn-refresh-list') {
  //     this.$confirm('¿Quiere eliminar el registro?', () => {
  //       this.$service.graphql({
  //         query: `
  //           mutation{
  //             experienciaTrabajoDelete(id: ${id}){
  //               deleted
  //             }
  //           }
  //         `
  //       }).then(response => {
  //         if (response && response[url + 'Delete'] && response[url + 'Delete'].deleted) {
  //           this.$message.success('Registro eliminado correctamente');
  //           this.recargarExperienciaTrabajo()
  //         }
  //       });
  //     });
  //   },

    
	},

	// Definición de componentes importados
	components: {
		CrudTable,
		CrearActualizarExperienciaTrabajo,
    VerDocumento
	}
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/ExperienciaTrabajo.vue